export default __webpack_public_path__ + "sound/alert.b794de8f55ab35bb62fa4be67895ecd3.mp3";